import React from "react"
import { ICellRendererParams } from "ag-grid-community"
import { Button } from "@blueprintjs/core"

interface RemoveButtonParams extends ICellRendererParams {
  onRemove: (data: any) => void
}

const RemoveButtonRenderer = (params: RemoveButtonParams) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    params.onRemove(params.data)
  }

  return params.data.query_key !== -1 ? (
    <Button small minimal icon="cross" intent="danger" onClick={handleClick} />
  ) : null
}

export default RemoveButtonRenderer
